import { viagemIntermunicipalApi } from "../BaseService";
export const getMapaRotas = async (municipioPartida, municipioDestino, empresaId, diaSemana, token) => {
    const api = viagemIntermunicipalApi(token);
    const response = await api.get("/open/listagem-rotas", {
        params: { municipioPartida, empresaId, diaSemana, municipioDestino },
    });
    return response.data;
};
export const getListagemMunicipios = async (token) => {
    const api = viagemIntermunicipalApi(token);
    const response = await api.get("/open/listagem-municipios");
    return response.data;
};
export const getListagemEmpresas = async (token) => {
    const api = viagemIntermunicipalApi(token);
    const response = await api.get("/open/listagem-empresa");
    return response.data;
};
